import React from 'react';
import { Button } from '@popmenu/admin-ui';
import { makeStyles, Typography, Link } from '@popmenu/common-ui';
import Grid from '~/shared/Grid';
import { useIntl } from 'react-intl';
import { useAppointmentLink } from '~/admin/hooks/useAppointmentLink';

const useStyles = makeStyles(({ spacing }) => ({
  actionButtons: {
    marginTop: spacing(3.5),
  },
  container: {
    minHeight: 'calc(100vh - 200px)',
    padding: spacing(5, 2),
  },
  content: {
    maxWidth: '39rem',
  },
  description: {
    marginTop: spacing(2),
  },
  footerText: {
    marginTop: spacing(2),
  },
  title: {
    marginBottom: spacing(4),
  },
}));

const useMessages = () => {
  const intl = useIntl();

  return {
    dashboardLink: intl.formatMessage({ defaultMessage: 'MyPop dashboard' }),
    descriptionLine1: intl.formatMessage({ defaultMessage: 'It looks like your email is already associated with a MyPop restaurant.' }),
    descriptionLine2: intl.formatMessage({ defaultMessage: 'Schedule a meeting with our Sales team and we’ll help you with the next steps on another restaurant.' }),
    descriptionLine2Support: intl.formatMessage({ defaultMessage: 'Visit our Support Center and we’ll help you with the next steps on another restaurant.' }),
    footerPrefix: intl.formatMessage({ defaultMessage: 'Or, go to your ' }),
    scheduleMeeting: intl.formatMessage({ defaultMessage: 'Schedule a meeting with Sales' }),
    title: intl.formatMessage({ defaultMessage: 'You already have a MyPop restaurant' }),
  };
};

const ExistingAccountNotice = () => {
  const classes = useStyles();
  const messages = useMessages();
  const { appointmentLink: meetingLink } = useAppointmentLink();

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" className={classes.container}>
      <Grid item xs={12} className={classes.content}>
        <Typography align="center" variant="h5" className={classes.title}>
          {messages.title}
        </Typography>
        <React.Fragment>
          <Typography align="center" variant="body1" className={classes.description}>
            {messages.descriptionLine1}
          </Typography>
          <Typography align="center" variant="body1" className={classes.description}>
            {meetingLink ? messages.descriptionLine2 : messages.descriptionLine2Support}
          </Typography>
        </React.Fragment>

        <Grid container direction="column" alignItems="center" className={classes.actionButtons} spacing={2}>
          <Grid item>
            {meetingLink ? (
              <Button
                component="a"
                data-testid="existing-account-schedule-sales"
                href={meetingLink}
                rel="noopener noreferrer"
                target="_blank"
              >
                {messages.scheduleMeeting}
              </Button>
            ) : (
              <Button
                data-testid="existing-account-schedule-sales"
                disabled
              >
                {messages.scheduleMeeting}
              </Button>
            )}
          </Grid>
          <Grid item>
            <Typography align="center" variant="body2" className={classes.footerText}>
              {messages.footerPrefix}
              <Link href="/" data-testid="existing-account-go-dashboard" style={{ display: 'inline' }}>
                {messages.dashboardLink}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ExistingAccountNotice;
